// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportingConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';

export default class ExportingConfiguration {
  @observable isEnableAsyncExporting = false;
  @observable exportQueueFileStorage = 0;
  @observable azureFileSrvceCnnctionString = null;
  @observable asyncExportingPath = null;
  @observable awsS3BucketName = null;
  @observable awsAccessKey = null;
  @observable awsSecretKey = null;
  @observable region = null;
  @observable isEnableSmartExporting = false;
  @observable isEnableAsyncExportEncryption = false;
  @observable asyncExportingInterval = 0;
  @observable isRefreshExportingInterval = false;
  @observable asyncRefreshExportingInterval = 0;

  constructor(data: any) {
    data && this.populateData(data);
  }

  /**
   * Populate Data
   */
  @action
  populateData(data: any) {
    this.isEnableAsyncExporting = data.isEnableAsyncExporting;
    this.asyncExportingPath = data.asyncExportingPath;
    this.isEnableSmartExporting = data.isEnableSmartExporting;
    this.isEnableAsyncExportEncryption = data.isEnableAsyncExportEncryption;
    this.asyncExportingInterval = data.asyncExportingInterval;
    this.asyncRefreshExportingInterval = data.asyncRefreshExportingInterval;
    this.isRefreshExportingInterval = data.asyncRefreshExportingInterval > 0;
    this.exportQueueFileStorage = data.exportQueueFileStorage > 0 ? data.exportQueueFileStorage : 1;
    this.azureFileSrvceCnnctionString = data.azureFileSrvceCnnctionString;
    this.awsS3BucketName = data.awsS3BucketName;
    this.awsAccessKey = data.awsAccessKey;
    this.awsSecretKey = data.awsSecretKey;
    this.region = data.region;
  }

  /**
   * Set value by key
   */
  setValueByKey(key: string, value: any) {
    this[key] = value;
  }

  /**
   * Build data for save
   */
  buildDataForSave() {
    return{
      isEnableAsyncExporting: this.isEnableAsyncExporting,
      asyncExportingPath: this.asyncExportingPath,
      isEnableSmartExporting: this.isEnableSmartExporting,
      isEnableAsyncExportEncryption: this.isEnableAsyncExportEncryption,
      asyncRefreshExportingInterval: this.asyncRefreshExportingInterval,
      asyncArchiveExportingInterval: this.asyncArchiveExportingInterval,
      asyncExportingInterval: this.asyncExportingInterval,
      exportQueueFileStorage: this.exportQueueFileStorage,
      azureFileSrvceCnnctionString: this.azureFileSrvceCnnctionString,
      awsS3BucketName: this.awsS3BucketName,
      awsAccessKey: this.awsAccessKey,
      awsSecretKey: this.awsSecretKey,
      region: this.region
    }
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ExportingConfiguration.js